import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { AgreementOfferActionTypes } from './types'

export const sendAgreementOffer = createAction(
  AgreementOfferActionTypes.SEND_AGREEMENT_OFFER,
  action =>
    (
      agency_partner_hotel_agreements: [
        {
          agency_partner_hotel_offer_id: Id
          agency_partner_id: Id
          agreement_id: Id
          active: Boolean
          description?: String
        }
      ]
    ) =>
      action({ agency_partner_hotel_agreements })
)

export const sendAgreementOfferFailure = createAction(
  AgreementOfferActionTypes.SEND_AGREEMENT_OFFER_FAILURE,
  action => (message: string) => action({ message })
)

export const sendAgreementOfferSuccess = createAction(
  AgreementOfferActionTypes.SEND_AGREEMENT_OFFER_SUCCESS,
  action => () => action()
)
